<template>
	<img v-bind="$attrs" :src="APP_ICON" alt="" class="app-brand-icon block object-contain" :class="{ 'app-brand-icon--png': APP_ICON_IS_PNG }" />
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false })

import { APP_ICON, APP_ICON_IS_PNG } from '@/config/app'
</script>

<style scoped>
.app-brand-icon--png {
	border-radius: inherit;
}
</style>
